export default {
  get: function () {
    return {
      'AuditFileTemplateId': {
        label: '_'
      },

      '*Name': {
        label: 'AP File Template Name',
        width: 300
      },

      'HasVATSeparateString': {
        label: 'Detailed VAT',
        width: 90,
        source: true,
        options: [
          {
            text: 'Yes',
            status: true
          },
          {
            text: 'No',
            status: true
          }
        ],
        editable: false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/FundingInvoiceAndAPSettings/APFileTemplates/APFileTemplatesModel.js